module.exports = __webpack_public_path__ + "img/pattern3.048029e.svg";